/**
 * Handles the fee toggle event.
 * @param {Event} event - The event object.
 */
function feeToggleHandler(event) {
    if (!event || !event.target) {
        return;
    }

    let feeToggle = event.target;
    const feeToggleFieldset = feeToggle.closest("fieldset");
    const adjacentFieldset = feeToggleFieldset.nextElementSibling;

    if (feeToggle.value === "custom" && feeToggle.checked) {
        adjacentFieldset.hidden = false;
        adjacentFieldset.nextElementSibling.hidden = true;
    } else {
        adjacentFieldset.hidden = true;
        adjacentFieldset.nextElementSibling.hidden = false;
    }
}

const feeToggles = document.querySelectorAll('.feeTog input[type="radio"]');

if (feeToggles.length > 0) {
    feeToggles.forEach((feeToggle) => {
        feeToggle.addEventListener("change", feeToggleHandler);
    });

    feeToggles.forEach((feeToggle) => {
        if (feeToggle.checked) {
            feeToggleHandler({ target: feeToggle });
        }
    });
}

export { feeToggleHandler };
